module.exports = __webpack_public_path__ + "media/images/interfaz-86e76a4ae4da372c0f4d21361b3d95e5.png";